import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

const trendingImages = [
  'https://readdy.ai/api/search-image?query=Glamorous%20entertainment%20red%20carpet%20scene%20with%20dramatic%20lighting%2C%20paparazzi%20flashes%2C%20luxurious%20atmosphere%2C%20dark%20background%20with%20golden%20accents%2C%20editorial%20fashion%20magazine%20style%2C%20cinematic%20lighting%2C%20rich%20contrast%2C%20clean%20composition&width=800&height=800&seq=trending-grid-01&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20with%20professional%20lighting%20setup%2C%20ring%20light%20glow%2C%20multiple%20screens%2C%20modern%20tech%20atmosphere%2C%20dark%20background%2C%20neon%20accents%2C%20dramatic%20contrast%2C%20editorial%20photography%20style%2C%20clean%20composition&width=800&height=800&seq=trending-grid-02&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Social%20media%20influencer%20content%20creation%20scene%2C%20smartphone%20with%20bright%20screen%2C%20trendy%20accessories%2C%20warm%20ambient%20lighting%2C%20modern%20minimal%20setup%2C%20dark%20background%20with%20warm%20accents%2C%20editorial%20style%2C%20clean%20composition&width=800&height=800&seq=trending-grid-03&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Breaking%20news%20concept%20with%20abstract%20fire%20and%20sparks%2C%20dramatic%20lighting%2C%20dark%20background%2C%20warm%20orange%20and%20red%20tones%2C%20editorial%20concept%20photography%2C%20clean%20minimal%20composition%2C%20powerful%20visual%20impact&width=800&height=800&seq=trending-grid-04&orientation=squarish',
];

export default function TrendingGrid() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            热门吃瓜栏目
          </h2>
          <p className="text-sm text-secondary-500 max-w-md mx-auto">
            四大吃瓜频道，覆盖娱乐圈、直播圈、网红圈、社会热点，一网打尽
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {categories.map((cat, idx) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative aspect-square rounded-xl overflow-hidden cursor-pointer"
            >
              <img
                src={trendingImages[idx]}
                alt={cat.name}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-white">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mb-4">
                  <i className={`${cat.icon} text-4xl md:text-5xl`}></i>
                </div>
                <h3 className="font-heading text-xl md:text-2xl font-bold mb-2">{cat.name}</h3>
                <p className="text-xs text-white/70 max-w-[200px] text-center leading-relaxed">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}